module.exports = __webpack_public_path__ + "static/image_2_thumb-deed3689ef713ee2f1216a595d63a76e.jpg";